<template lang="pug">
.page-footer
  .product_column.footer_column
    .column_title(
      @click="showProduct = !showProduct"
    )
      span {{ $t('产品') }}
      i.el-icon-arrow-right(v-if="!showProduct")
      i.el-icon-arrow-down(v-else)
    transition(
      name="fade"
    )
      .column_items(v-if="showProduct")
        .column_item(
          v-for="item in products"
          @click="navTo(item.link)"
        )
          span {{ item.name }}
          img(src="@/assets/icon-entrance.png")
  .service_column.footer_column
    .column_title(
      @click="showService = !showService"
    )
      span {{ $t('服务') }}
      i.el-icon-arrow-right(v-if="!showService")
      i.el-icon-arrow-down(v-else)
    transition(
      name="fade"
    )
      .column_items(v-if="showService")
        .column_item(
          v-for="(item,idx) in services"
          @click="navTo(item.link)"
          :key="idx"
        )
          span {{ item.name }}
          img(src="@/assets/icon-entrance.png")
  .about_column.footer_column
    .column_title(
      @click="showAbout = !showAbout"
    )
      span {{ $t('关于复歌') }}
      i.el-icon-arrow-right(v-if="!showAbout")
      i.el-icon-arrow-down(v-else)
    transition(
      name="fade"
    )
      .column_items(v-if="showAbout")
        .column_item(
          @click="$router.push('/about')"
        )
          span {{ $t('关于复歌') }}
          img(src="@/assets/icon-entrance.png")
  .contact_column.footer_column
    .column_title {{ $t('联系方式') }}
    .column_items
      .column_item 上海市静安区威海路511号1403室
      .column_item client@fugetech.com
      .column_item 021-62583355
  .qrCode_column.footer_column
    .qrCode_column__content
      div
        img(
          src="@/assets/wechat-qrcode.png"
        )
        span {{ $t('扫码关注我们') }}
      div
        img(src="@/assets/qrCode1.png", alt="alt")
        span 好快活 | 人才情报局
      div
        img(src="@/assets/qrCode2.png", alt="alt")
        span 好快活 | 名人榜
      //- div
      //-   img(
      //-     src="@/assets/miniprogram-qrcode.jpg"
      //-   )
      //-   span {{ $t('贵了么 小程序') }}
    .column_item © All rights reserved 2009-{{new Date().getFullYear()}}.FugeTech,Inc.
    a.column_item(href="https://beian.miit.gov.cn") 沪ICP备10009106号-1
</template>

<script>
export default {
  data () {
    return {
      showService: false,
      showProduct: false,
      showAbout: false,
      products: [
        {
          name: '好快活',
          link: '/product/happy'
        },
        {
          name: 'Libra',
          link: '/product/libra'
        },
        {
          name: 'Bid Agent',
          link: '/product/bid_agent'
        },
        {
          name: 'Rimix',
          link: '/product/rimix'
        },
        {
          name: 'Data Hub',
          link: '/product/data_hub'
        },
        {
          name: '贵了么',
          link: '/product/guileme'
        },
        {
          name: 'iMedia Matrix',
          link: '/product/i_media_matrix'
        },
        {
          name: 'iMedia Tracker',
          link: '/product/i_media_tracker'
        },
      ],
      services: [
        // {
        //   name: '金融服务',
        //   link: '/service/financial-service?activeIndex=0'
        // },
        {
          name: '广告运营',
          link: '/service/ad-marketing?activeIndex=0'
        },
        {
          name: '资源直采',
          link: '/service/resource-purchasing'
        },
        {
          name: '媒体审计',
          link: '/service/price-auditing'
        },
        {
          name: '数字化管理',
          link: '/service/digital-management'
        },
        {
          name: '效果评估',
          link: '/service/effect-evaluation'
        }
      ]
    }
  },
  methods: {
    navTo (link) {
      this.$router.push(link)
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="stylus">
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}

@media (max-width: 767px)
  .page-footer
    padding 0 24px
  // .qrCode_column__content
  //   width 100%

@media (max-width: 1370px) and (min-width: 768px)
  .page-footer
    padding 0 72px
  // .qrCode_column__content
  //   width 400px
  //   margin auto

.page-footer
  margin-top 20px
  margin-bottom 38px
  display flex
  flex-direction column

.footer_column
  .column_title
    font-size 16px
    font-weight 600
    color #303251
    padding 12px 0
    display flex
    justify-content space-between
    border-bottom 1px solid rgba(48, 50, 81, 0.15)
  .column_items
    margin-bottom 24px
    border-bottom 1px solid rgba(48, 50, 81, 0.15)
    .column_item
      font-size 16px
      color #6e6f85
      margin 24px 0
      cursor pointer
      display flex
      justify-content space-between
      img
        width 20px
        height 20px
    .column_item:hover
      text-decoration underline
  .qrCode_column__content
    // margin-top 30px
    text-align center
    display flex
    flex-wrap: wrap
    justify-content space-around
    img
      width 100px
      height 100px
    span
      margin-top 16px
      font-size 16px
      min-width 120px
      color #6e6f85
      display block
.contact_column
  .column_title
    border-bottom none
    padding-bottom 0px
    margin-bottom 16px
  .column_items .column_item:hover
    text-decoration none
    cursor auto
.qrCode_column
  padding-top 10px
  border-bottom none
  text-align center
  .qrCode_column__content
    span
      margin-bottom 24px
  .column_item
    margin-bottom 12px
    color #acadb9
</style>
